import { Box, ColorOptions, Spacer, Text } from '@jfs/ui-new'
import React from 'react'
import { styles } from './styles'

interface ListRowProps {
  item: any
  index: number
  sizeConfig?: Array<number>
  disabled: boolean
  onPress: () => void
}

const colorMap = {
  success: 'GREEN',
  failed: 'ERROR',
  failure: 'ERROR',
  inprocess: 'ORANGE',
  awaited: 'ORANGE',
  'refund failed': 'ERROR',
  'refund accepted': 'GREEN',
  none: 'BLACK',
}

const getColor = (item: any) => {
  return colorMap[(item as keyof typeof colorMap) || 'none']
}

const ListItemRefunds = ({ item, onPress, disabled }: ListRowProps) => {
  return (
    <Box {...styles.container} disabled={disabled} onPress={onPress}>
      <Box flexGrow={1}>
        <Text numberOfLines={1}>{item.customerName}</Text>
        <Spacer size="SMALLEST" />
        <Box flexDirection="row" f={1}>
          <Text numberOfLines={1} fontSize="TINY" color="PRIMARY_GREY">
            {item?.date}
          </Text>
          <Box {...styles.dotView} />
          <Box f={1}>
            {/* <Text numberOfLines={1} fontSize="TINY" color="PRIMARY_GREY">
              {item?.paymentMode !== 'NA' ? item?.paymentMode : ''}
            </Text> */}
          </Box>
        </Box>
      </Box>
      <Spacer direction={'horizontal'} size={4} />
      <Box>
        <Text numberOfLines={1} textAlign="right">
          {item.refundAmount}
        </Text>
        <Spacer size="SMALLEST" />
        <UIText type={item?.refundStatus?.toLowerCase()} />
      </Box>
    </Box>
  )
}
const ListItemSettlement = ({ item, onPress, disabled }: ListRowProps) => {
  return (
    <Box {...styles.container} disabled={disabled} onPress={onPress}>
      <Box flexGrow={1}>
        <Text numberOfLines={1}>{item?.date ?? 'NA'}</Text>
        <Spacer size="SMALLEST" />
        <Text numberOfLines={1} fontSize="TINY" color="PRIMARY_GREY">
          {item?.referenceNumber ?? 'NA'}
        </Text>
      </Box>
      <Spacer direction={'horizontal'} size={4} />
      <Box>
        <Text numberOfLines={1} textAlign="right" fontWeight="BOLD">
          {item?.settledAmount ?? 'NA'}
        </Text>
      </Box>
    </Box>
  )
}

const ListItemTxn = ({ item, onPress, disabled, index }: ListRowProps) => {
  return (
    <Box {...styles.container} disabled={disabled} onPress={onPress} testID={`listItemTxn${index}`}>
      <Box flexGrow={1}>
        <Text numberOfLines={1}>{item.customerName}</Text>
        <Spacer size="SMALLEST" />
        <Box flexDirection="row" f={1}>
          <Text fontSize="TINY" color="PRIMARY_GREY" numberOfLines={1}>
            {item.date}
          </Text>
          <Box {...styles.dotView} f={1} />
          <Box flexDirection="row" f={1}>
            <Text fontSize="TINY" color="PRIMARY_GREY" numberOfLines={1}>
              {item.paymentMode?.slice(0, 24)}
            </Text>
          </Box>
        </Box>
      </Box>
      <Spacer direction={'horizontal'} size={8} />
      <Box>
        <Text textAlign="right">{item.totalAmount}</Text>
        <Spacer size="SMALLEST" />
        <UIText type={item?.transactionStatus?.toLowerCase()} />
      </Box>
    </Box>
  )
}

const UIText = ({ type }: any) => {
  return (
    <Text color={getColor(type) as ColorOptions} numberOfLines={1} fontSize="TINY" textAlign="right">
      {type.slice(0, 1).toUpperCase() + type.slice(1)}
    </Text>
  )
}

export { ListItemSettlement, ListItemTxn, ListItemRefunds }
